<template>
  <el-dialog title="提示" :visible.sync="visible" width="468px" :append-to-body="true" center>
    <div class="pop-tips">
      <div class="title">{{ title }}</div>
      <div class="hot">注销后将不能编辑</div>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="注销原因" prop="comment" class="form-item">
        <el-input type="textarea" v-model="form.comment" :rows='4' maxlength="64" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popCancel",
  props: {
    title: {
      type: String,
      default: '注销'
    },
    reportList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      visible: false,
      form: {
        comment: ''
      },
      rules: {
        comment: [
          { required: true, message: '请填写注销原因', trigger: 'blur' },
        ]
      }
    }
  },
  created() {


  },
  methods: {
    show() {
      this.visible = true
    },
    ok() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('setCancel',this.form.comment)
          this.visible = false
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.pop-tips {
  text-align: center;
  line-height: 1.5;
  margin-bottom: 20px;

  .title {
    font-size: 14px;
    color: #2F3030;
  }

  .hot {
    color: #D6223D;
    font-size: 14px;
  }
}

.form-item {
  margin-bottom: 0;
}
</style>
